import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetRecommendedRegistryOnboardingSurveyResultsQueryVariables = Types.Exact<{
  handle: Types.Scalars['String'];
}>;

export type GetRecommendedRegistryOnboardingSurveyResultsQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    firebaseCreateAt?: { __typename?: 'Date'; milliseconds: number } | null;
    info: { __typename?: 'EventInfo'; id: string; eventType: Types.EventType };
    recommendation: {
      __typename?: 'RecommendEvent';
      registryOnboardingSurvey: {
        __typename?: 'RecommendRegistryOnboardingSurveyResults';
        id: string;
        registryTypes?: Array<string> | null;
        registeringAtOtherStores?: boolean | null;
        coupleInterests?: Array<string> | null;
        interestedInBrowserButton?: boolean | null;
        lastUpdatedAt?: { __typename?: 'Date'; milliseconds: number } | null;
      };
    };
  } | null;
};

export type AdminRegistryFragment = {
  __typename?: 'Registry';
  recommendationStatus: Types.RegistryRecommendationStatus;
  id: string;
  nameV0204?: string | null;
  urlV0204?: string | null;
  imageUrlV0204?: string | null;
  wantSync?: boolean | null;
  type: Types.RegistryType;
  isStandalonesType: boolean;
  isSyncingType: boolean;
  isTransferredType: boolean;
  storeName?: string | null;
  cannotSync: boolean;
  hasItems: boolean;
  orders: Array<{
    __typename?: 'RegistryOrder';
    id: string;
    name: string;
    email: string;
    note?: string | null;
    isPurchased: boolean;
    isDropship: boolean;
    status?: string | null;
    orderTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
    orderedAt: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number };
    lineItems: Array<{
      __typename?: 'LineItem';
      locator: string;
      quantity: number;
      isGetCashEquivalent: boolean;
      lineTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
      registryItem?: { __typename?: 'RegistryItem'; id: string } | null;
      lineItemData: { __typename?: 'RegistryOrderLineItemData'; donationFundPlatformType?: Types.DonationFundPaymentMethodEnum | null; correctedQuantity: number };
      annotations: { __typename?: 'RegistryOrderLineItemAnnotations'; isEdelivery?: boolean | null };
      frozenProductData: {
        __typename?: 'RegistrySummaryProductData';
        title: string;
        customType: Types.CustomItemDataType;
        price: {
          __typename?: 'RegistryMonetaryValue';
          valueInMinorUnits: number;
          floatingPointDecimalString: string;
          currency?: { __typename?: 'RegistryCurrency'; id: string; code: string; places: number } | null;
        };
        photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
      };
    }>;
    fulfillment?: {
      __typename?: 'RegistryFulfillment';
      status: string;
      statusPageUrl?: string | null;
      orderNumber: string;
      shipments?: Array<{
        __typename?: 'RegistryFulfillmentShipment';
        trackingInformation?: {
          __typename?: 'RegistryFulfillmentShipmentTrackingInformation';
          url?: string | null;
          company?: string | null;
          trackingNumber?: string | null;
        } | null;
      }> | null;
    } | null;
    shippingAddress?: {
      __typename?: 'RegistryOrderShippingAddress';
      hash?: string | null;
      name?: string | null;
      address1?: string | null;
      address2?: string | null;
      city?: string | null;
      state?: string | null;
      postalCode?: string | null;
      country?: string | null;
      countryCode?: string | null;
    } | null;
  } | null>;
  items?: Array<{
    __typename?: 'RegistryItem';
    id: string;
    isGroupGiftingEnabled?: boolean | null;
    isGetCashEquivalent?: boolean | null;
    note?: string | null;
    externallyOwned: boolean;
    canEditProductData: boolean;
    storeName?: string | null;
    fpIndex: number;
    stillNeeded: number;
    alreadyPurchased?: number | null;
    alreadyReserved?: number | null;
    totalRequested?: number | null;
    isHidden: boolean;
    mustHave: boolean;
    catalogItem?: { __typename?: 'ProductCatalogItem'; id: string; inventory: { __typename?: 'ProductInventoryResult'; maxQty: number } } | null;
    createAt: { __typename?: 'Date'; milliseconds: number; timestamp: any; timezone: string };
    productData: {
      __typename?: 'RegistryItemProductData';
      brand?: string | null;
      customType?: Types.CustomItemDataType | null;
      title: string;
      externalUrl?: string | null;
      checkoutUrl?: string | null;
      pdpUrl?: string | null;
      description?: string | null;
      isFullPrice: boolean;
      legacyType: Types.LegacyRegistryItemType;
      registryItem: { __typename?: 'RegistryItem'; id: string };
      price?: {
        __typename?: 'RegistryMonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'RegistryCurrency'; id: string; code: string; places: number } | null;
      } | null;
      fullPrice?: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      } | null;
      photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
    };
    donationFund?: {
      __typename?: 'DonationFund';
      id: string;
      fundType: Types.CustomItemDataType;
      suggestedQuantityStillNeeded?: number | null;
      donationsAreCapped: boolean;
      enforceSuggestedDonationAmount: boolean;
      hideFundingGoal: boolean;
      progressToGoalPercent?: number | null;
      fpIndex?: number | null;
      title: string;
      url?: string | null;
      description?: string | null;
      enableCashOrCheck?: boolean | null;
      enableAppPlatform: boolean;
      enableJoyCredit: boolean;
      mustHave: boolean;
      donations: Array<{
        __typename?: 'DonationFundDonation';
        id: string;
        name: string;
        email: string;
        note?: string | null;
        platformType?: Types.DonationFundPaymentMethodEnum | null;
        amount: {
          __typename?: 'MonetaryValue';
          valueInMinorUnits: number;
          floatingPointDecimalString: string;
          currency?: { __typename?: 'Currency'; code: string; places: number } | null;
        };
        orderedAt: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number };
      }>;
      goalMonetaryValue?: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      } | null;
      suggestedDonationMonetaryValue?: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      } | null;
      platform?: {
        __typename?: 'DonationFundPlatform';
        id?: string | null;
        type: Types.DonationFundPlatformTypeEnum;
        name: string;
        link?: string | null;
        username?: string | null;
      } | null;
      photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
      progressToGoal?: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      } | null;
      amountTillGoalIsReached?: {
        __typename?: 'MonetaryValue';
        valueInMinorUnits: number;
        floatingPointDecimalString: string;
        currency?: { __typename?: 'Currency'; code: string; places: number } | null;
      } | null;
      currency: { __typename?: 'RegistryCurrency'; code: string; id: string; displayName: string };
    } | null;
  }> | null;
  transferredRegistryData?: {
    __typename?: 'TransferredRegistryData';
    transferredAt: { __typename?: 'Date'; dateString: string; timestamp: any; timezone: string; milliseconds: number };
    lastPublicCheck?: {
      __typename?: 'ExternalRegistryStatusData';
      isPublic: boolean;
      checkedAt: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number };
    } | null;
  } | null;
  lastSyncAt?: { __typename?: 'Date'; timestamp: any } | null;
  myReservedOrders: Array<{
    __typename?: 'RegistryOrder';
    id: string;
    name: string;
    email: string;
    note?: string | null;
    isPurchased: boolean;
    isDropship: boolean;
    status?: string | null;
    orderTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
    orderedAt: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number };
    lineItems: Array<{
      __typename?: 'LineItem';
      locator: string;
      quantity: number;
      isGetCashEquivalent: boolean;
      lineTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
      registryItem?: { __typename?: 'RegistryItem'; id: string } | null;
      lineItemData: { __typename?: 'RegistryOrderLineItemData'; donationFundPlatformType?: Types.DonationFundPaymentMethodEnum | null; correctedQuantity: number };
      annotations: { __typename?: 'RegistryOrderLineItemAnnotations'; isEdelivery?: boolean | null };
      frozenProductData: {
        __typename?: 'RegistrySummaryProductData';
        title: string;
        customType: Types.CustomItemDataType;
        price: {
          __typename?: 'RegistryMonetaryValue';
          valueInMinorUnits: number;
          floatingPointDecimalString: string;
          currency?: { __typename?: 'RegistryCurrency'; id: string; code: string; places: number } | null;
        };
        photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
      };
    }>;
    fulfillment?: {
      __typename?: 'RegistryFulfillment';
      status: string;
      statusPageUrl?: string | null;
      orderNumber: string;
      shipments?: Array<{
        __typename?: 'RegistryFulfillmentShipment';
        trackingInformation?: {
          __typename?: 'RegistryFulfillmentShipmentTrackingInformation';
          url?: string | null;
          company?: string | null;
          trackingNumber?: string | null;
        } | null;
      }> | null;
    } | null;
    shippingAddress?: {
      __typename?: 'RegistryOrderShippingAddress';
      hash?: string | null;
      name?: string | null;
      address1?: string | null;
      address2?: string | null;
      city?: string | null;
      state?: string | null;
      postalCode?: string | null;
      country?: string | null;
      countryCode?: string | null;
    } | null;
  } | null>;
  myPurchasedOrders: Array<{
    __typename?: 'RegistryOrder';
    id: string;
    name: string;
    email: string;
    note?: string | null;
    isPurchased: boolean;
    isDropship: boolean;
    status?: string | null;
    orderTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
    orderedAt: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number };
    lineItems: Array<{
      __typename?: 'LineItem';
      locator: string;
      quantity: number;
      isGetCashEquivalent: boolean;
      lineTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
      registryItem?: { __typename?: 'RegistryItem'; id: string } | null;
      lineItemData: { __typename?: 'RegistryOrderLineItemData'; donationFundPlatformType?: Types.DonationFundPaymentMethodEnum | null; correctedQuantity: number };
      annotations: { __typename?: 'RegistryOrderLineItemAnnotations'; isEdelivery?: boolean | null };
      frozenProductData: {
        __typename?: 'RegistrySummaryProductData';
        title: string;
        customType: Types.CustomItemDataType;
        price: {
          __typename?: 'RegistryMonetaryValue';
          valueInMinorUnits: number;
          floatingPointDecimalString: string;
          currency?: { __typename?: 'RegistryCurrency'; id: string; code: string; places: number } | null;
        };
        photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
      };
    }>;
    fulfillment?: {
      __typename?: 'RegistryFulfillment';
      status: string;
      statusPageUrl?: string | null;
      orderNumber: string;
      shipments?: Array<{
        __typename?: 'RegistryFulfillmentShipment';
        trackingInformation?: {
          __typename?: 'RegistryFulfillmentShipmentTrackingInformation';
          url?: string | null;
          company?: string | null;
          trackingNumber?: string | null;
        } | null;
      }> | null;
    } | null;
    shippingAddress?: {
      __typename?: 'RegistryOrderShippingAddress';
      hash?: string | null;
      name?: string | null;
      address1?: string | null;
      address2?: string | null;
      city?: string | null;
      state?: string | null;
      postalCode?: string | null;
      country?: string | null;
      countryCode?: string | null;
    } | null;
  } | null>;
  mySession?: { __typename?: 'RegistrySession'; email: string } | null;
};

export type GetAdminRegistryRegistriesQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type GetAdminRegistryRegistriesQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    registry?: { __typename?: 'EventData'; id: string; disableWhiteGloveforSyncedItems: boolean; disableWhiteGloveforTransferredItems: boolean } | null;
    info: {
      __typename?: 'EventInfo';
      id: string;
      registry: Array<{
        __typename?: 'Registry';
        recommendationStatus: Types.RegistryRecommendationStatus;
        id: string;
        nameV0204?: string | null;
        urlV0204?: string | null;
        imageUrlV0204?: string | null;
        wantSync?: boolean | null;
        type: Types.RegistryType;
        isStandalonesType: boolean;
        isSyncingType: boolean;
        isTransferredType: boolean;
        storeName?: string | null;
        cannotSync: boolean;
        hasItems: boolean;
        orders: Array<{
          __typename?: 'RegistryOrder';
          id: string;
          name: string;
          email: string;
          note?: string | null;
          isPurchased: boolean;
          isDropship: boolean;
          status?: string | null;
          orderTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
          orderedAt: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number };
          lineItems: Array<{
            __typename?: 'LineItem';
            locator: string;
            quantity: number;
            isGetCashEquivalent: boolean;
            lineTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
            registryItem?: { __typename?: 'RegistryItem'; id: string } | null;
            lineItemData: { __typename?: 'RegistryOrderLineItemData'; donationFundPlatformType?: Types.DonationFundPaymentMethodEnum | null; correctedQuantity: number };
            annotations: { __typename?: 'RegistryOrderLineItemAnnotations'; isEdelivery?: boolean | null };
            frozenProductData: {
              __typename?: 'RegistrySummaryProductData';
              title: string;
              customType: Types.CustomItemDataType;
              price: {
                __typename?: 'RegistryMonetaryValue';
                valueInMinorUnits: number;
                floatingPointDecimalString: string;
                currency?: { __typename?: 'RegistryCurrency'; id: string; code: string; places: number } | null;
              };
              photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
            };
          }>;
          fulfillment?: {
            __typename?: 'RegistryFulfillment';
            status: string;
            statusPageUrl?: string | null;
            orderNumber: string;
            shipments?: Array<{
              __typename?: 'RegistryFulfillmentShipment';
              trackingInformation?: {
                __typename?: 'RegistryFulfillmentShipmentTrackingInformation';
                url?: string | null;
                company?: string | null;
                trackingNumber?: string | null;
              } | null;
            }> | null;
          } | null;
          shippingAddress?: {
            __typename?: 'RegistryOrderShippingAddress';
            hash?: string | null;
            name?: string | null;
            address1?: string | null;
            address2?: string | null;
            city?: string | null;
            state?: string | null;
            postalCode?: string | null;
            country?: string | null;
            countryCode?: string | null;
          } | null;
        } | null>;
        items?: Array<{
          __typename?: 'RegistryItem';
          id: string;
          isGroupGiftingEnabled?: boolean | null;
          isGetCashEquivalent?: boolean | null;
          note?: string | null;
          externallyOwned: boolean;
          canEditProductData: boolean;
          storeName?: string | null;
          fpIndex: number;
          stillNeeded: number;
          alreadyPurchased?: number | null;
          alreadyReserved?: number | null;
          totalRequested?: number | null;
          isHidden: boolean;
          mustHave: boolean;
          catalogItem?: { __typename?: 'ProductCatalogItem'; id: string; inventory: { __typename?: 'ProductInventoryResult'; maxQty: number } } | null;
          createAt: { __typename?: 'Date'; milliseconds: number; timestamp: any; timezone: string };
          productData: {
            __typename?: 'RegistryItemProductData';
            brand?: string | null;
            customType?: Types.CustomItemDataType | null;
            title: string;
            externalUrl?: string | null;
            checkoutUrl?: string | null;
            pdpUrl?: string | null;
            description?: string | null;
            isFullPrice: boolean;
            legacyType: Types.LegacyRegistryItemType;
            registryItem: { __typename?: 'RegistryItem'; id: string };
            price?: {
              __typename?: 'RegistryMonetaryValue';
              valueInMinorUnits: number;
              floatingPointDecimalString: string;
              currency?: { __typename?: 'RegistryCurrency'; id: string; code: string; places: number } | null;
            } | null;
            fullPrice?: {
              __typename?: 'MonetaryValue';
              valueInMinorUnits: number;
              floatingPointDecimalString: string;
              currency?: { __typename?: 'Currency'; code: string; places: number } | null;
            } | null;
            photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
          };
          donationFund?: {
            __typename?: 'DonationFund';
            id: string;
            fundType: Types.CustomItemDataType;
            suggestedQuantityStillNeeded?: number | null;
            donationsAreCapped: boolean;
            enforceSuggestedDonationAmount: boolean;
            hideFundingGoal: boolean;
            progressToGoalPercent?: number | null;
            fpIndex?: number | null;
            title: string;
            url?: string | null;
            description?: string | null;
            enableCashOrCheck?: boolean | null;
            enableAppPlatform: boolean;
            enableJoyCredit: boolean;
            mustHave: boolean;
            donations: Array<{
              __typename?: 'DonationFundDonation';
              id: string;
              name: string;
              email: string;
              note?: string | null;
              platformType?: Types.DonationFundPaymentMethodEnum | null;
              amount: {
                __typename?: 'MonetaryValue';
                valueInMinorUnits: number;
                floatingPointDecimalString: string;
                currency?: { __typename?: 'Currency'; code: string; places: number } | null;
              };
              orderedAt: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number };
            }>;
            goalMonetaryValue?: {
              __typename?: 'MonetaryValue';
              valueInMinorUnits: number;
              floatingPointDecimalString: string;
              currency?: { __typename?: 'Currency'; code: string; places: number } | null;
            } | null;
            suggestedDonationMonetaryValue?: {
              __typename?: 'MonetaryValue';
              valueInMinorUnits: number;
              floatingPointDecimalString: string;
              currency?: { __typename?: 'Currency'; code: string; places: number } | null;
            } | null;
            platform?: {
              __typename?: 'DonationFundPlatform';
              id?: string | null;
              type: Types.DonationFundPlatformTypeEnum;
              name: string;
              link?: string | null;
              username?: string | null;
            } | null;
            photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
            progressToGoal?: {
              __typename?: 'MonetaryValue';
              valueInMinorUnits: number;
              floatingPointDecimalString: string;
              currency?: { __typename?: 'Currency'; code: string; places: number } | null;
            } | null;
            amountTillGoalIsReached?: {
              __typename?: 'MonetaryValue';
              valueInMinorUnits: number;
              floatingPointDecimalString: string;
              currency?: { __typename?: 'Currency'; code: string; places: number } | null;
            } | null;
            currency: { __typename?: 'RegistryCurrency'; code: string; id: string; displayName: string };
          } | null;
        }> | null;
        transferredRegistryData?: {
          __typename?: 'TransferredRegistryData';
          transferredAt: { __typename?: 'Date'; dateString: string; timestamp: any; timezone: string; milliseconds: number };
          lastPublicCheck?: {
            __typename?: 'ExternalRegistryStatusData';
            isPublic: boolean;
            checkedAt: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number };
          } | null;
        } | null;
        lastSyncAt?: { __typename?: 'Date'; timestamp: any } | null;
        myReservedOrders: Array<{
          __typename?: 'RegistryOrder';
          id: string;
          name: string;
          email: string;
          note?: string | null;
          isPurchased: boolean;
          isDropship: boolean;
          status?: string | null;
          orderTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
          orderedAt: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number };
          lineItems: Array<{
            __typename?: 'LineItem';
            locator: string;
            quantity: number;
            isGetCashEquivalent: boolean;
            lineTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
            registryItem?: { __typename?: 'RegistryItem'; id: string } | null;
            lineItemData: { __typename?: 'RegistryOrderLineItemData'; donationFundPlatformType?: Types.DonationFundPaymentMethodEnum | null; correctedQuantity: number };
            annotations: { __typename?: 'RegistryOrderLineItemAnnotations'; isEdelivery?: boolean | null };
            frozenProductData: {
              __typename?: 'RegistrySummaryProductData';
              title: string;
              customType: Types.CustomItemDataType;
              price: {
                __typename?: 'RegistryMonetaryValue';
                valueInMinorUnits: number;
                floatingPointDecimalString: string;
                currency?: { __typename?: 'RegistryCurrency'; id: string; code: string; places: number } | null;
              };
              photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
            };
          }>;
          fulfillment?: {
            __typename?: 'RegistryFulfillment';
            status: string;
            statusPageUrl?: string | null;
            orderNumber: string;
            shipments?: Array<{
              __typename?: 'RegistryFulfillmentShipment';
              trackingInformation?: {
                __typename?: 'RegistryFulfillmentShipmentTrackingInformation';
                url?: string | null;
                company?: string | null;
                trackingNumber?: string | null;
              } | null;
            }> | null;
          } | null;
          shippingAddress?: {
            __typename?: 'RegistryOrderShippingAddress';
            hash?: string | null;
            name?: string | null;
            address1?: string | null;
            address2?: string | null;
            city?: string | null;
            state?: string | null;
            postalCode?: string | null;
            country?: string | null;
            countryCode?: string | null;
          } | null;
        } | null>;
        myPurchasedOrders: Array<{
          __typename?: 'RegistryOrder';
          id: string;
          name: string;
          email: string;
          note?: string | null;
          isPurchased: boolean;
          isDropship: boolean;
          status?: string | null;
          orderTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
          orderedAt: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number };
          lineItems: Array<{
            __typename?: 'LineItem';
            locator: string;
            quantity: number;
            isGetCashEquivalent: boolean;
            lineTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
            registryItem?: { __typename?: 'RegistryItem'; id: string } | null;
            lineItemData: { __typename?: 'RegistryOrderLineItemData'; donationFundPlatformType?: Types.DonationFundPaymentMethodEnum | null; correctedQuantity: number };
            annotations: { __typename?: 'RegistryOrderLineItemAnnotations'; isEdelivery?: boolean | null };
            frozenProductData: {
              __typename?: 'RegistrySummaryProductData';
              title: string;
              customType: Types.CustomItemDataType;
              price: {
                __typename?: 'RegistryMonetaryValue';
                valueInMinorUnits: number;
                floatingPointDecimalString: string;
                currency?: { __typename?: 'RegistryCurrency'; id: string; code: string; places: number } | null;
              };
              photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
            };
          }>;
          fulfillment?: {
            __typename?: 'RegistryFulfillment';
            status: string;
            statusPageUrl?: string | null;
            orderNumber: string;
            shipments?: Array<{
              __typename?: 'RegistryFulfillmentShipment';
              trackingInformation?: {
                __typename?: 'RegistryFulfillmentShipmentTrackingInformation';
                url?: string | null;
                company?: string | null;
                trackingNumber?: string | null;
              } | null;
            }> | null;
          } | null;
          shippingAddress?: {
            __typename?: 'RegistryOrderShippingAddress';
            hash?: string | null;
            name?: string | null;
            address1?: string | null;
            address2?: string | null;
            city?: string | null;
            state?: string | null;
            postalCode?: string | null;
            country?: string | null;
            countryCode?: string | null;
          } | null;
        } | null>;
        mySession?: { __typename?: 'RegistrySession'; email: string } | null;
      }>;
    };
  } | null;
};

export type GetAdminRegistryOrdersQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type GetAdminRegistryOrdersQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    registry?: {
      __typename?: 'EventData';
      id: string;
      orders?: Array<{
        __typename?: 'RegistryOrder';
        id: string;
        name: string;
        email: string;
        note?: string | null;
        isPurchased: boolean;
        isDropship: boolean;
        status?: string | null;
        orderTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
        orderedAt: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number };
        lineItems: Array<{
          __typename?: 'LineItem';
          locator: string;
          quantity: number;
          isGetCashEquivalent: boolean;
          lineTags: Array<{ __typename?: 'CommerceTag'; key: string; value: string }>;
          registryItem?: { __typename?: 'RegistryItem'; id: string } | null;
          lineItemData: { __typename?: 'RegistryOrderLineItemData'; donationFundPlatformType?: Types.DonationFundPaymentMethodEnum | null; correctedQuantity: number };
          annotations: { __typename?: 'RegistryOrderLineItemAnnotations'; isEdelivery?: boolean | null };
          frozenProductData: {
            __typename?: 'RegistrySummaryProductData';
            title: string;
            customType: Types.CustomItemDataType;
            price: {
              __typename?: 'RegistryMonetaryValue';
              valueInMinorUnits: number;
              floatingPointDecimalString: string;
              currency?: { __typename?: 'RegistryCurrency'; id: string; code: string; places: number } | null;
            };
            photos: Array<{ __typename?: 'Photo'; id: string; url: string }>;
          };
        }>;
        fulfillment?: {
          __typename?: 'RegistryFulfillment';
          status: string;
          statusPageUrl?: string | null;
          orderNumber: string;
          shipments?: Array<{
            __typename?: 'RegistryFulfillmentShipment';
            trackingInformation?: {
              __typename?: 'RegistryFulfillmentShipmentTrackingInformation';
              url?: string | null;
              company?: string | null;
              trackingNumber?: string | null;
            } | null;
          }> | null;
        } | null;
        shippingAddress?: {
          __typename?: 'RegistryOrderShippingAddress';
          hash?: string | null;
          name?: string | null;
          address1?: string | null;
          address2?: string | null;
          city?: string | null;
          state?: string | null;
          postalCode?: string | null;
          country?: string | null;
          countryCode?: string | null;
        } | null;
      }> | null;
    } | null;
  } | null;
};

export type GetAdminRegistryDataQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type GetAdminRegistryDataQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    info: {
      __typename?: 'EventInfo';
      id: string;
      eventDisplayName?: string | null;
      eventType: Types.EventType;
      finalizedDate?: { __typename?: 'Date'; timestamp: any; timezone: string; milliseconds: number } | null;
    };
    registry?: {
      __typename?: 'EventData';
      id: string;
      itemCount: { __typename?: 'RegistryItemCount'; everything: number };
      checklist?: { __typename?: 'RegistryChecklist'; id: string } | null;
      summary?: { __typename?: 'EventRegistriesSummary'; cannotSync: boolean; lastSyncAt?: { __typename?: 'Date'; timestamp: any } | null } | null;
      currency?: { __typename?: 'RegistryCurrency'; isDefault: boolean; id: string; displayName: string; code: string; rank?: number | null } | null;
      shippingAddress?: {
        __typename?: 'ShippingAddress';
        name?: string | null;
        address1: string;
        address2?: string | null;
        phone?: string | null;
        city: string;
        state: string;
        postalCode?: string | null;
        country: string;
        countryCode?: string | null;
        validated: boolean;
        hash?: string | null;
      } | null;
      donationFundInfo: {
        __typename?: 'DonationFundInfo';
        defaultPlatform?: { __typename?: 'DonationFundPlatform'; id?: string | null; type: Types.DonationFundPlatformTypeEnum; username?: string | null } | null;
        defaultSuggestedDonationMonetaryValue?: { __typename?: 'MonetaryValue'; valueInMinorUnits: number } | null;
        platforms: Array<{ __typename?: 'DonationFundPlatform'; id?: string | null; type: Types.DonationFundPlatformTypeEnum; username?: string | null; link?: string | null }>;
        items: Array<{
          __typename?: 'DonationFund';
          id: string;
          platform?: { __typename?: 'DonationFundPlatform'; id?: string | null; type: Types.DonationFundPlatformTypeEnum } | null;
        }>;
      };
    } | null;
    registryPage: Array<{ __typename?: 'EventPage'; id: string; disabled: boolean; subTitle?: string | null }>;
    migrationPages: Array<{ __typename?: 'EventPage'; id: string; pageSlug: string; pageKind: Types.PageKind }>;
    eventUsers: Array<{ __typename?: 'EventUser'; id: string; status: Types.EventUserStatus }>;
  } | null;
  registryPageContainer?: { __typename?: 'PageContainer'; id: string; contentType?: Types.PageContentType | null; pageKind: Types.PageKind; note?: string | null } | null;
};

export type GetGiftTransactionThankYouAssociationsQueryVariables = Types.Exact<{
  args?: Types.InputMaybe<Types.MessageRelationshipCriteria>;
}>;

export type GetGiftTransactionThankYouAssociationsQuery = {
  __typename?: 'Query';
  getMessageRelationships: Array<{
    __typename?: 'MessageRelationResult';
    id: string;
    relationshipTag?: string | null;
    externalMessageId: string;
    status?: string | null;
    redirectUri?: string | null;
  } | null>;
};

export type SetRegistryEventDataMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  payload: Types.RegistryEventDataInput;
}>;

export type SetRegistryEventDataMutation = {
  __typename?: 'Mutation';
  setRegistryEventData: {
    __typename?: 'EventData';
    id: string;
    disableWhiteGloveforSyncedItems: boolean;
    disableWhiteGloveforTransferredItems: boolean;
    disableWhiteGloveforPartnerItems: boolean;
  };
};

export type GetRegistryEventDataQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type GetRegistryEventDataQuery = {
  __typename?: 'Query';
  getRegistryEventData?: {
    __typename?: 'EventData';
    id: string;
    disableWhiteGloveforSyncedItems: boolean;
    disableWhiteGloveforTransferredItems: boolean;
    disableWhiteGloveforPartnerItems: boolean;
  } | null;
};

export type SetHideRegistryInMessagingSettingMutationVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
  payload: Types.RegistryEventDataInput;
}>;

export type SetHideRegistryInMessagingSettingMutation = {
  __typename?: 'Mutation';
  setRegistryEventData: { __typename?: 'EventData'; id: string; hideRegistryInMessaging: boolean };
};

export type GetHideRegistryInMessagingSettingQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type GetHideRegistryInMessagingSettingQuery = {
  __typename?: 'Query';
  getRegistryEventData?: { __typename?: 'EventData'; id: string; hideRegistryInMessaging: boolean } | null;
};

export type StartRefundMutationVariables = Types.Exact<{
  registryOrderId: Types.Scalars['ID'];
  refundMethod: Types.SalesOrderRefundMethod;
}>;

export type StartRefundMutation = { __typename?: 'Mutation'; startRefund?: any | null };

export type GetEventPreviewDataQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type GetEventPreviewDataQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    firebaseId: string;
    eventDesign?: {
      __typename?: 'EventDesign';
      id: string;
      hasUnpublishedChanges: boolean;
      hasVisitedDesignPage?: boolean | null;
      guestSiteTarget: Types.GuestSiteTargetEnum;
      brannanNavigation: Types.BrannanNavigation;
      useCustomTheme: boolean;
      accent?: string | null;
      customCss: string;
      linkAndButtonColor?: string | null;
      artFontColor?: string | null;
      artBackgroundColor?: string | null;
      pageBackgroundColor?: string | null;
      pageFontColor?: string | null;
      websiteLayout: { __typename?: 'DesignLayout'; id: string; layoutType: Types.DesignLayoutType; name: string };
      font: { __typename?: 'Font'; id: string; display: string; fontFamily: string; textTransform: Types.FontWeight };
      fonts?: Array<{
        __typename?: 'FontPackConfiguration';
        id: string;
        category: Types.Category;
        size?: number | null;
        sizePercent?: number | null;
        font?: { __typename?: 'Font'; id: string; fontFamily: string; fontSize: number; fontWeight: number; firebaseFontKey: string } | null;
      }> | null;
      theme: {
        __typename?: 'Theme';
        id: string;
        themeId: string;
        name: string;
        colorSchemes: Array<{ __typename?: 'ThemeColorScheme'; id: string; colors: Array<{ __typename?: 'Color'; hex: string; isLight: boolean }> }>;
        designLayouts: Array<{ __typename?: 'DesignLayout'; id: string }>;
        websiteLayoutBrannanSettings?: {
          __typename?: 'WebsiteLayoutBrannanSettings';
          brannanBackgroundTransparency?: {
            __typename?: 'DesignPreferenceRange';
            supportsCustomization: boolean;
            id: string;
            featureName: string;
            featureValueType: Types.FeatureValueType;
            rangeValue: number;
            rangeMax: number;
            rangeMin: number;
            rangeStep: number;
          } | null;
        } | null;
        websiteLayoutAlohaSettings?: {
          __typename?: 'WebsiteLayoutAlohaSettings';
          alohaColorPreference?: {
            __typename?: 'DesignPreferenceColor';
            id: string;
            featureName: string;
            featureValueType: Types.FeatureValueType;
            supportsCustomization: boolean;
            colorValue: { __typename?: 'Color'; hex: string; isLight: boolean };
          } | null;
          alohaTextColorPreference?: {
            __typename?: 'DesignPreferenceColor';
            id: string;
            featureName: string;
            featureValueType: Types.FeatureValueType;
            supportsCustomization: boolean;
            colorValue: { __typename?: 'Color'; hex: string; isLight: boolean };
          } | null;
        } | null;
      };
      masthead: { __typename?: 'EventDesignMasthead'; id?: string | null; isEnabled: boolean };
      colorPalette: Array<{ __typename?: 'ColorSet'; id: string; color: { __typename?: 'Color'; hex: string; isLight: boolean } }>;
      activeWebsiteHeaderPresentationLayout?: { __typename?: 'WebsiteHeaderPresentationSettings'; dataJSON: any; schemaURL: string; websiteLayout: string; id: string } | null;
      customTheme?: {
        __typename?: 'CustomTheme';
        id: string;
        desktopThemeAsset?: { __typename?: 'CustomThemeAsset'; id: string; assetURL: string } | null;
        mobileThemeAsset?: { __typename?: 'CustomThemeAsset'; id: string; assetURL: string } | null;
      } | null;
      designPreferences: Array<
        | {
            __typename?: 'EventDesignPreferenceBoolean';
            id: string;
            featureId: string;
            featureName: string;
            featureType: Types.DesignFeatureType;
            featureValueType: Types.FeatureValueType;
            booleanValue: boolean;
          }
        | {
            __typename?: 'EventDesignPreferenceColorPointer';
            id: string;
            featureName: string;
            featureType: Types.DesignFeatureType;
            colorPointer?: number | null;
            colorPointerPosition?: Types.ColorPointerLocation | null;
          }
        | {
            __typename?: 'EventDesignPreferenceRange';
            id: string;
            featureId: string;
            featureName: string;
            featureType: Types.DesignFeatureType;
            featureValueType: Types.FeatureValueType;
            rangeValue: number;
          }
      >;
    } | null;
    registry?: { __typename?: 'EventData'; id: string; itemCount: { __typename?: 'RegistryItemCount'; everything: number } } | null;
    registryPage: Array<{
      __typename?: 'EventPage';
      id: string;
      photoV2?: { __typename?: 'DefaultPagePhoto'; id: string; url: string } | { __typename?: 'Photo'; id: string; url: string } | null;
    }>;
  } | null;
  registryPageContainer?: {
    __typename?: 'PageContainer';
    id: string;
    contentType?: Types.PageContentType | null;
    pageKind: Types.PageKind;
    mainPhotoV2?: { __typename?: 'DefaultPagePhoto'; id: string; url: string } | { __typename?: 'Photo'; id: string; url: string } | null;
  } | null;
};

export type GetEventDelayShipSettingQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type GetEventDelayShipSettingQuery = { __typename?: 'Query'; getRegistryEventData?: { __typename?: 'EventData'; id: string; hideDelayShipSetting?: boolean | null } | null };

export const AdminRegistryFragmentDoc = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AdminRegistry' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Registry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Registry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recommendationStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orders' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryOrder' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryItemInventory' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Registry' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Registry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nameV0204' } },
          { kind: 'Field', name: { kind: 'Name', value: 'urlV0204' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageUrlV0204' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wantSync' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isStandalonesType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSyncingType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTransferredType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transferredRegistryData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transferredAt' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateString' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastPublicCheck' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'checkedAt' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } }] },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isPublic' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'storeName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cannotSync' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasItems' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastSyncAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'timestamp' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryItem' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myReservedOrders' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryOrder' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myPurchasedOrders' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryOrder' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mySession' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'email' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Date' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryItem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isGroupGiftingEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isGetCashEquivalent' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAt' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externallyOwned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canEditProductData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'storeName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'registryItem' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'checkoutUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pdpUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'price' },
                  name: { kind: 'Name', value: 'priceAugmented' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fullPrice' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isFullPrice' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photos' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'legacyType' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fpIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stillNeeded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alreadyPurchased' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alreadyReserved' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalRequested' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'donationFund' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DonationFund' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mustHave' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MonetaryValue' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MonetaryValue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currency' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'places' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DonationFund' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DonationFund' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'donations' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DonationFundDonation' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fundType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'goalMonetaryValue' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'suggestedDonationMonetaryValue' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'suggestedQuantityStillNeeded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'donationsAreCapped' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enforceSuggestedDonationAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideFundingGoal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DonationFundPlatform' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progressToGoal' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'amountTillGoalIsReached' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'progressToGoalPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fpIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enableCashOrCheck' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enableAppPlatform' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enableJoyCredit' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currency' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'mustHave' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DonationFundDonation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DonationFundDonation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'amount' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'platformType' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DonationFundPlatform' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DonationFundPlatform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'link' } },
          { kind: 'Field', name: { kind: 'Name', value: 'username' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryOrder' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryOrder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPurchased' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDropship' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lineItems' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LineItem' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fulfillment' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryFulfillment' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shippingAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LineItem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'LineItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'locator' } },
          { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lineTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registryItem' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lineItemData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'donationFundPlatformType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'correctedQuantity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'annotations' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isEdelivery' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'frozenProductData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'price' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photos' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isGetCashEquivalent' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryFulfillment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryFulfillment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'statusPageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipments' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryFulfillmentShipment' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryFulfillmentShipment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryFulfillmentShipment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'trackingInformation' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryFulfillmentShipmentTrackingInformation' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryFulfillmentShipmentTrackingInformation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryFulfillmentShipmentTrackingInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'trackingNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryItemInventory' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'catalogItem' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'inventory' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'maxQty' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export const GetRecommendedRegistryOnboardingSurveyResultsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRecommendedRegistryOnboardingSurveyResults' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'handle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'handle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'firebaseCreateAt' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recommendation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'registryOnboardingSurvey' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastUpdatedAt' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } }] },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'registryTypes' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'registeringAtOtherStores' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'coupleInterests' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'interestedInBrowserButton' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetRecommendedRegistryOnboardingSurveyResultsQuery__
 *
 * To run a query within a React component, call `useGetRecommendedRegistryOnboardingSurveyResultsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecommendedRegistryOnboardingSurveyResultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecommendedRegistryOnboardingSurveyResultsQuery({
 *   variables: {
 *      handle: // value for 'handle'
 *   },
 * });
 */
export function useGetRecommendedRegistryOnboardingSurveyResultsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetRecommendedRegistryOnboardingSurveyResultsQuery, GetRecommendedRegistryOnboardingSurveyResultsQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetRecommendedRegistryOnboardingSurveyResultsQuery, GetRecommendedRegistryOnboardingSurveyResultsQueryVariables>(
    GetRecommendedRegistryOnboardingSurveyResultsDocument,
    baseOptions,
  );
}
export function useGetRecommendedRegistryOnboardingSurveyResultsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRecommendedRegistryOnboardingSurveyResultsQuery, GetRecommendedRegistryOnboardingSurveyResultsQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetRecommendedRegistryOnboardingSurveyResultsQuery, GetRecommendedRegistryOnboardingSurveyResultsQueryVariables>(
    GetRecommendedRegistryOnboardingSurveyResultsDocument,
    baseOptions,
  );
}
export type GetRecommendedRegistryOnboardingSurveyResultsQueryHookResult = ReturnType<typeof useGetRecommendedRegistryOnboardingSurveyResultsQuery>;
export type GetRecommendedRegistryOnboardingSurveyResultsLazyQueryHookResult = ReturnType<typeof useGetRecommendedRegistryOnboardingSurveyResultsLazyQuery>;
export type GetRecommendedRegistryOnboardingSurveyResultsQueryResult = Apollo.QueryResult<
  GetRecommendedRegistryOnboardingSurveyResultsQuery,
  GetRecommendedRegistryOnboardingSurveyResultsQueryVariables
>;
export const GetAdminRegistryRegistriesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAdminRegistryRegistries' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'registry' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'disableWhiteGloveforSyncedItems' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'disableWhiteGloveforTransferredItems' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'registry' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'AdminRegistry' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'AdminRegistry' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Registry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Registry' } },
          { kind: 'Field', name: { kind: 'Name', value: 'recommendationStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orders' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryOrder' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryItemInventory' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Registry' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Registry' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'nameV0204' } },
          { kind: 'Field', name: { kind: 'Name', value: 'urlV0204' } },
          { kind: 'Field', name: { kind: 'Name', value: 'imageUrlV0204' } },
          { kind: 'Field', name: { kind: 'Name', value: 'wantSync' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isStandalonesType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isSyncingType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isTransferredType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transferredRegistryData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'transferredAt' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dateString' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastPublicCheck' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'checkedAt' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } }] },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'isPublic' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'storeName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cannotSync' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasItems' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastSyncAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'timestamp' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'items' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryItem' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myReservedOrders' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryOrder' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'myPurchasedOrders' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryOrder' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mySession' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'email' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Date' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryItem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isGroupGiftingEnabled' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isGetCashEquivalent' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAt' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
                { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'externallyOwned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'canEditProductData' } },
          { kind: 'Field', name: { kind: 'Name', value: 'storeName' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'registryItem' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'checkoutUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pdpUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'price' },
                  name: { kind: 'Name', value: 'priceAugmented' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'fullPrice' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'isFullPrice' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photos' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'legacyType' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fpIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'stillNeeded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alreadyPurchased' } },
          { kind: 'Field', name: { kind: 'Name', value: 'alreadyReserved' } },
          { kind: 'Field', name: { kind: 'Name', value: 'totalRequested' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'donationFund' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DonationFund' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isHidden' } },
          { kind: 'Field', name: { kind: 'Name', value: 'mustHave' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'MonetaryValue' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'MonetaryValue' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
          { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currency' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'places' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DonationFund' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DonationFund' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'donations' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DonationFundDonation' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'fundType' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'goalMonetaryValue' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'suggestedDonationMonetaryValue' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'suggestedQuantityStillNeeded' } },
          { kind: 'Field', name: { kind: 'Name', value: 'donationsAreCapped' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enforceSuggestedDonationAmount' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hideFundingGoal' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'platform' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DonationFundPlatform' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'photos' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'progressToGoal' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'amountTillGoalIsReached' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'progressToGoalPercent' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fpIndex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'title' } },
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'description' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enableCashOrCheck' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enableAppPlatform' } },
          { kind: 'Field', name: { kind: 'Name', value: 'enableJoyCredit' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'currency' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'mustHave' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DonationFundDonation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DonationFundDonation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'amount' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'MonetaryValue' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'platformType' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DonationFundPlatform' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DonationFundPlatform' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'link' } },
          { kind: 'Field', name: { kind: 'Name', value: 'username' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryOrder' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryOrder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPurchased' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDropship' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lineItems' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LineItem' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fulfillment' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryFulfillment' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shippingAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LineItem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'LineItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'locator' } },
          { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lineTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registryItem' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lineItemData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'donationFundPlatformType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'correctedQuantity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'annotations' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isEdelivery' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'frozenProductData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'price' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photos' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isGetCashEquivalent' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryFulfillment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryFulfillment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'statusPageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipments' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryFulfillmentShipment' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryFulfillmentShipment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryFulfillmentShipment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'trackingInformation' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryFulfillmentShipmentTrackingInformation' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryFulfillmentShipmentTrackingInformation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryFulfillmentShipmentTrackingInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'trackingNumber' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryItemInventory' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'catalogItem' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'inventory' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'maxQty' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAdminRegistryRegistriesQuery__
 *
 * To run a query within a React component, call `useGetAdminRegistryRegistriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminRegistryRegistriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminRegistryRegistriesQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetAdminRegistryRegistriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAdminRegistryRegistriesQuery, GetAdminRegistryRegistriesQueryVariables>) {
  return ApolloReactHooks.useQuery<GetAdminRegistryRegistriesQuery, GetAdminRegistryRegistriesQueryVariables>(GetAdminRegistryRegistriesDocument, baseOptions);
}
export function useGetAdminRegistryRegistriesLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminRegistryRegistriesQuery, GetAdminRegistryRegistriesQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetAdminRegistryRegistriesQuery, GetAdminRegistryRegistriesQueryVariables>(GetAdminRegistryRegistriesDocument, baseOptions);
}
export type GetAdminRegistryRegistriesQueryHookResult = ReturnType<typeof useGetAdminRegistryRegistriesQuery>;
export type GetAdminRegistryRegistriesLazyQueryHookResult = ReturnType<typeof useGetAdminRegistryRegistriesLazyQuery>;
export type GetAdminRegistryRegistriesQueryResult = Apollo.QueryResult<GetAdminRegistryRegistriesQuery, GetAdminRegistryRegistriesQueryVariables>;
export const GetAdminRegistryOrdersDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAdminRegistryOrders' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'registry' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'orders' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryOrder' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Date' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryOrder' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryOrder' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'note' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPurchased' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDropship' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'orderedAt' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lineItems' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LineItem' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fulfillment' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryFulfillment' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shippingAddress' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LineItem' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'LineItem' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'locator' } },
          { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lineTags' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                { kind: 'Field', name: { kind: 'Name', value: 'value' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registryItem' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lineItemData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'donationFundPlatformType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'correctedQuantity' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'annotations' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'isEdelivery' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'frozenProductData' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customType' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'price' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'code' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'places' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'floatingPointDecimalString' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'photos' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'isGetCashEquivalent' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryFulfillment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryFulfillment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          { kind: 'Field', name: { kind: 'Name', value: 'statusPageUrl' } },
          { kind: 'Field', name: { kind: 'Name', value: 'orderNumber' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'shipments' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryFulfillmentShipment' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryFulfillmentShipment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryFulfillmentShipment' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'trackingInformation' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryFulfillmentShipmentTrackingInformation' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryFulfillmentShipmentTrackingInformation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryFulfillmentShipmentTrackingInformation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'url' } },
          { kind: 'Field', name: { kind: 'Name', value: 'company' } },
          { kind: 'Field', name: { kind: 'Name', value: 'trackingNumber' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAdminRegistryOrdersQuery__
 *
 * To run a query within a React component, call `useGetAdminRegistryOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminRegistryOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminRegistryOrdersQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetAdminRegistryOrdersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAdminRegistryOrdersQuery, GetAdminRegistryOrdersQueryVariables>) {
  return ApolloReactHooks.useQuery<GetAdminRegistryOrdersQuery, GetAdminRegistryOrdersQueryVariables>(GetAdminRegistryOrdersDocument, baseOptions);
}
export function useGetAdminRegistryOrdersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminRegistryOrdersQuery, GetAdminRegistryOrdersQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetAdminRegistryOrdersQuery, GetAdminRegistryOrdersQueryVariables>(GetAdminRegistryOrdersDocument, baseOptions);
}
export type GetAdminRegistryOrdersQueryHookResult = ReturnType<typeof useGetAdminRegistryOrdersQuery>;
export type GetAdminRegistryOrdersLazyQueryHookResult = ReturnType<typeof useGetAdminRegistryOrdersLazyQuery>;
export type GetAdminRegistryOrdersQueryResult = Apollo.QueryResult<GetAdminRegistryOrdersQuery, GetAdminRegistryOrdersQueryVariables>;
export const GetAdminRegistryDataDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAdminRegistryData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventDisplayName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'eventType' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'finalizedDate' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Date' } }] },
                      },
                    ],
                  },
                },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryShippingAddressFragment' } },
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DonationFundInfoFragment' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'registry' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'itemCount' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'everything' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'checklist' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'summary' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'lastSyncAt' },
                              selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'timestamp' } }] },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'cannotSync' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'currency' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventRegistryCurrency' } }] },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'registryPage' },
                  name: { kind: 'Name', value: 'pages' },
                  arguments: [
                    { kind: 'Argument', name: { kind: 'Name', value: 'type' }, value: { kind: 'EnumValue', value: 'registry' } },
                    { kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'BooleanValue', value: true } },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', alias: { kind: 'Name', value: 'subTitle' }, name: { kind: 'Name', value: 'pageSubTitleV0918' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'disabled' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'migrationPages' },
                  name: { kind: 'Name', value: 'pages' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'BooleanValue', value: true } }],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pageSlug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pageKind' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventUsers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'registryPageContainer' },
            name: { kind: 'Name', value: 'pageContainerBySlug' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'payload' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'eventName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'pageSlug' }, value: { kind: 'StringValue', value: 'registry', block: false } },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: { kind: 'ObjectValue', fields: [{ kind: 'ObjectField', name: { kind: 'Name', value: 'admin' }, value: { kind: 'BooleanValue', value: true } }] },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageKind' } },
                { kind: 'Field', name: { kind: 'Name', value: 'note' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Date' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Date' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'timestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timezone' } },
          { kind: 'Field', name: { kind: 'Name', value: 'milliseconds' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryShippingAddressFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registry' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'shippingAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'validated' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'currency' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventRegistryCurrency' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventRegistryCurrency' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryCurrency' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'RegistryCurrencyCodes' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isDefault' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'RegistryCurrencyCodes' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryCurrency' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'code' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rank' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DonationFundInfoFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Event' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'registry' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'donationFundInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'defaultPlatform' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'defaultSuggestedDonationMonetaryValue' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'valueInMinorUnits' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'platforms' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'username' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'link' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'platform' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetAdminRegistryDataQuery__
 *
 * To run a query within a React component, call `useGetAdminRegistryDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminRegistryDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminRegistryDataQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetAdminRegistryDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAdminRegistryDataQuery, GetAdminRegistryDataQueryVariables>) {
  return ApolloReactHooks.useQuery<GetAdminRegistryDataQuery, GetAdminRegistryDataQueryVariables>(GetAdminRegistryDataDocument, baseOptions);
}
export function useGetAdminRegistryDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAdminRegistryDataQuery, GetAdminRegistryDataQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetAdminRegistryDataQuery, GetAdminRegistryDataQueryVariables>(GetAdminRegistryDataDocument, baseOptions);
}
export type GetAdminRegistryDataQueryHookResult = ReturnType<typeof useGetAdminRegistryDataQuery>;
export type GetAdminRegistryDataLazyQueryHookResult = ReturnType<typeof useGetAdminRegistryDataLazyQuery>;
export type GetAdminRegistryDataQueryResult = Apollo.QueryResult<GetAdminRegistryDataQuery, GetAdminRegistryDataQueryVariables>;
export const GetGiftTransactionThankYouAssociationsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetGiftTransactionThankYouAssociations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'args' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'MessageRelationshipCriteria' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getMessageRelationships' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'args' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'args' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'relationshipTag' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalMessageId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'redirectUri' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetGiftTransactionThankYouAssociationsQuery__
 *
 * To run a query within a React component, call `useGetGiftTransactionThankYouAssociationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGiftTransactionThankYouAssociationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGiftTransactionThankYouAssociationsQuery({
 *   variables: {
 *      args: // value for 'args'
 *   },
 * });
 */
export function useGetGiftTransactionThankYouAssociationsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetGiftTransactionThankYouAssociationsQuery, GetGiftTransactionThankYouAssociationsQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetGiftTransactionThankYouAssociationsQuery, GetGiftTransactionThankYouAssociationsQueryVariables>(
    GetGiftTransactionThankYouAssociationsDocument,
    baseOptions,
  );
}
export function useGetGiftTransactionThankYouAssociationsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetGiftTransactionThankYouAssociationsQuery, GetGiftTransactionThankYouAssociationsQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetGiftTransactionThankYouAssociationsQuery, GetGiftTransactionThankYouAssociationsQueryVariables>(
    GetGiftTransactionThankYouAssociationsDocument,
    baseOptions,
  );
}
export type GetGiftTransactionThankYouAssociationsQueryHookResult = ReturnType<typeof useGetGiftTransactionThankYouAssociationsQuery>;
export type GetGiftTransactionThankYouAssociationsLazyQueryHookResult = ReturnType<typeof useGetGiftTransactionThankYouAssociationsLazyQuery>;
export type GetGiftTransactionThankYouAssociationsQueryResult = Apollo.QueryResult<
  GetGiftTransactionThankYouAssociationsQuery,
  GetGiftTransactionThankYouAssociationsQueryVariables
>;
export const SetRegistryEventDataDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetRegistryEventData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryEventDataInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setRegistryEventData' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disableWhiteGloveforSyncedItems' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disableWhiteGloveforTransferredItems' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disableWhiteGloveforPartnerItems' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SetRegistryEventDataMutationFn = Apollo.MutationFunction<SetRegistryEventDataMutation, SetRegistryEventDataMutationVariables>;

/**
 * __useSetRegistryEventDataMutation__
 *
 * To run a mutation, you first call `useSetRegistryEventDataMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetRegistryEventDataMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setRegistryEventDataMutation, { data, loading, error }] = useSetRegistryEventDataMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetRegistryEventDataMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SetRegistryEventDataMutation, SetRegistryEventDataMutationVariables>) {
  return ApolloReactHooks.useMutation<SetRegistryEventDataMutation, SetRegistryEventDataMutationVariables>(SetRegistryEventDataDocument, baseOptions);
}
export type SetRegistryEventDataMutationHookResult = ReturnType<typeof useSetRegistryEventDataMutation>;
export type SetRegistryEventDataMutationResult = Apollo.MutationResult<SetRegistryEventDataMutation>;
export type SetRegistryEventDataMutationOptions = Apollo.BaseMutationOptions<SetRegistryEventDataMutation, SetRegistryEventDataMutationVariables>;
export const GetRegistryEventDataDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRegistryEventData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getRegistryEventData' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disableWhiteGloveforSyncedItems' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disableWhiteGloveforTransferredItems' } },
                { kind: 'Field', name: { kind: 'Name', value: 'disableWhiteGloveforPartnerItems' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetRegistryEventDataQuery__
 *
 * To run a query within a React component, call `useGetRegistryEventDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryEventDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryEventDataQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetRegistryEventDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryEventDataQuery, GetRegistryEventDataQueryVariables>) {
  return ApolloReactHooks.useQuery<GetRegistryEventDataQuery, GetRegistryEventDataQueryVariables>(GetRegistryEventDataDocument, baseOptions);
}
export function useGetRegistryEventDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryEventDataQuery, GetRegistryEventDataQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetRegistryEventDataQuery, GetRegistryEventDataQueryVariables>(GetRegistryEventDataDocument, baseOptions);
}
export type GetRegistryEventDataQueryHookResult = ReturnType<typeof useGetRegistryEventDataQuery>;
export type GetRegistryEventDataLazyQueryHookResult = ReturnType<typeof useGetRegistryEventDataLazyQuery>;
export type GetRegistryEventDataQueryResult = Apollo.QueryResult<GetRegistryEventDataQuery, GetRegistryEventDataQueryVariables>;
export const SetHideRegistryInMessagingSettingDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetHideRegistryInMessagingSetting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryEventDataInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setRegistryEventData' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'payload' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'payload' } } },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hideRegistryInMessaging' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type SetHideRegistryInMessagingSettingMutationFn = Apollo.MutationFunction<SetHideRegistryInMessagingSettingMutation, SetHideRegistryInMessagingSettingMutationVariables>;

/**
 * __useSetHideRegistryInMessagingSettingMutation__
 *
 * To run a mutation, you first call `useSetHideRegistryInMessagingSettingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetHideRegistryInMessagingSettingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setHideRegistryInMessagingSettingMutation, { data, loading, error }] = useSetHideRegistryInMessagingSettingMutation({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useSetHideRegistryInMessagingSettingMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<SetHideRegistryInMessagingSettingMutation, SetHideRegistryInMessagingSettingMutationVariables>,
) {
  return ApolloReactHooks.useMutation<SetHideRegistryInMessagingSettingMutation, SetHideRegistryInMessagingSettingMutationVariables>(
    SetHideRegistryInMessagingSettingDocument,
    baseOptions,
  );
}
export type SetHideRegistryInMessagingSettingMutationHookResult = ReturnType<typeof useSetHideRegistryInMessagingSettingMutation>;
export type SetHideRegistryInMessagingSettingMutationResult = Apollo.MutationResult<SetHideRegistryInMessagingSettingMutation>;
export type SetHideRegistryInMessagingSettingMutationOptions = Apollo.BaseMutationOptions<
  SetHideRegistryInMessagingSettingMutation,
  SetHideRegistryInMessagingSettingMutationVariables
>;
export const GetHideRegistryInMessagingSettingDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetHideRegistryInMessagingSetting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getRegistryEventData' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hideRegistryInMessaging' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetHideRegistryInMessagingSettingQuery__
 *
 * To run a query within a React component, call `useGetHideRegistryInMessagingSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHideRegistryInMessagingSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHideRegistryInMessagingSettingQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetHideRegistryInMessagingSettingQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetHideRegistryInMessagingSettingQuery, GetHideRegistryInMessagingSettingQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetHideRegistryInMessagingSettingQuery, GetHideRegistryInMessagingSettingQueryVariables>(GetHideRegistryInMessagingSettingDocument, baseOptions);
}
export function useGetHideRegistryInMessagingSettingLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHideRegistryInMessagingSettingQuery, GetHideRegistryInMessagingSettingQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetHideRegistryInMessagingSettingQuery, GetHideRegistryInMessagingSettingQueryVariables>(
    GetHideRegistryInMessagingSettingDocument,
    baseOptions,
  );
}
export type GetHideRegistryInMessagingSettingQueryHookResult = ReturnType<typeof useGetHideRegistryInMessagingSettingQuery>;
export type GetHideRegistryInMessagingSettingLazyQueryHookResult = ReturnType<typeof useGetHideRegistryInMessagingSettingLazyQuery>;
export type GetHideRegistryInMessagingSettingQueryResult = Apollo.QueryResult<GetHideRegistryInMessagingSettingQuery, GetHideRegistryInMessagingSettingQueryVariables>;
export const StartRefundDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StartRefund' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'registryOrderId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'refundMethod' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'SalesOrderRefundMethod' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startRefund' },
            arguments: [
              { kind: 'Argument', name: { kind: 'Name', value: 'registryOrderId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'registryOrderId' } } },
              { kind: 'Argument', name: { kind: 'Name', value: 'refundMethod' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'refundMethod' } } },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;
export type StartRefundMutationFn = Apollo.MutationFunction<StartRefundMutation, StartRefundMutationVariables>;

/**
 * __useStartRefundMutation__
 *
 * To run a mutation, you first call `useStartRefundMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartRefundMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startRefundMutation, { data, loading, error }] = useStartRefundMutation({
 *   variables: {
 *      registryOrderId: // value for 'registryOrderId'
 *      refundMethod: // value for 'refundMethod'
 *   },
 * });
 */
export function useStartRefundMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<StartRefundMutation, StartRefundMutationVariables>) {
  return ApolloReactHooks.useMutation<StartRefundMutation, StartRefundMutationVariables>(StartRefundDocument, baseOptions);
}
export type StartRefundMutationHookResult = ReturnType<typeof useStartRefundMutation>;
export type StartRefundMutationResult = Apollo.MutationResult<StartRefundMutation>;
export type StartRefundMutationOptions = Apollo.BaseMutationOptions<StartRefundMutation, StartRefundMutationVariables>;
export const GetEventPreviewDataDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEventPreviewData' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firebaseId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventDesign' },
                  arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'purpose' }, value: { kind: 'EnumValue', value: 'live' } }],
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventDesign' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'registry' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'itemCount' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'everything' } }] },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'registryPage' },
                  name: { kind: 'Name', value: 'pages' },
                  arguments: [
                    { kind: 'Argument', name: { kind: 'Name', value: 'type' }, value: { kind: 'EnumValue', value: 'registry' } },
                    { kind: 'Argument', name: { kind: 'Name', value: 'admin' }, value: { kind: 'BooleanValue', value: true } },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'photoV2' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Photo' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                ],
                              },
                            },
                            {
                              kind: 'InlineFragment',
                              typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DefaultPagePhoto' } },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'registryPageContainer' },
            name: { kind: 'Name', value: 'pageContainerBySlug' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'payload' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'eventName' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } },
                    { kind: 'ObjectField', name: { kind: 'Name', value: 'pageSlug' }, value: { kind: 'StringValue', value: 'registry', block: false } },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'options' },
                value: { kind: 'ObjectValue', fields: [{ kind: 'ObjectField', name: { kind: 'Name', value: 'admin' }, value: { kind: 'BooleanValue', value: true } }] },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contentType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'pageKind' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mainPhotoV2' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Photo' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DefaultPagePhoto' } },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventDesign' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesign' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasUnpublishedChanges' } },
          { kind: 'Field', name: { kind: 'Name', value: 'hasVisitedDesignPage' } },
          { kind: 'Field', name: { kind: 'Name', value: 'guestSiteTarget' } },
          { kind: 'Field', name: { kind: 'Name', value: 'brannanNavigation' } },
          { kind: 'Field', name: { kind: 'Name', value: 'useCustomTheme' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'websiteLayout' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DesignLayout' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'font' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'display' } },
                { kind: 'Field', name: { kind: 'Name', value: 'fontFamily' } },
                { kind: 'Field', name: { kind: 'Name', value: 'textTransform' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fonts' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'font' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fontFamily' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fontSize' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fontWeight' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firebaseFontKey' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'size' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sizePercent' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'theme' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'themeId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'colorSchemes' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ThemeColorScheme' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'designLayouts' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }] },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'websiteLayoutBrannanSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'brannanBackgroundTransparency' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'FragmentSpread', name: { kind: 'Name', value: 'DesignPreferenceRange' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'supportsCustomization' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'websiteLayoutAlohaSettings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'alohaColorPreference' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DesignPreferenceColor' } }] },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'alohaTextColorPreference' },
                        selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DesignPreferenceColor' } }] },
                      },
                    ],
                  },
                },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'accent' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'masthead' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isEnabled' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'customCss' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colorPalette' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'ColorSet' } }] },
          },
          { kind: 'FragmentSpread', name: { kind: 'Name', value: 'WebsiteEventColors' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activeWebsiteHeaderPresentationLayout' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'WebsiteHeaderPresentationSettings' } }] },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'useCustomTheme' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customTheme' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustomTheme' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'designPreferences' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPreferenceColorPointer' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventDesignPreferenceColorPointer' } }] },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPreferenceRange' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventDesignPreferenceRange' } }] },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPreferenceBoolean' } },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'EventDesignPreferenceBoolean' } }] },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DesignLayout' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DesignLayout' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'layoutType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ThemeColorScheme' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ThemeColorScheme' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colors' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Color' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Color' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Color' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'hex' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isLight' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DesignPreferenceRange' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DesignPreferenceRange' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureValueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rangeValue' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rangeMax' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rangeMin' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rangeStep' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsCustomization' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DesignPreferenceColor' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DesignPreferenceColor' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureValueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'supportsCustomization' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'colorValue' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Color' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ColorSet' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'ColorSet' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'color' },
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Color' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WebsiteEventColors' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesign' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'linkAndButtonColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'artFontColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'artBackgroundColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageBackgroundColor' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pageFontColor' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'WebsiteHeaderPresentationSettings' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'WebsiteHeaderPresentationSettings' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', alias: { kind: 'Name', value: 'id' }, name: { kind: 'Name', value: 'eventId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'dataJSON' } },
          { kind: 'Field', name: { kind: 'Name', value: 'schemaURL' } },
          { kind: 'Field', name: { kind: 'Name', value: 'websiteLayout' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustomTheme' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustomTheme' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'desktopThemeAsset' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assetURL' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'mobileThemeAsset' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assetURL' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventDesignPreferenceColorPointer' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPreferenceColorPointer' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'colorPointer' } },
          { kind: 'Field', name: { kind: 'Name', value: 'colorPointerPosition' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventDesignPreferenceRange' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPreferenceRange' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureValueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'rangeValue' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'EventDesignPreferenceBoolean' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'EventDesignPreferenceBoolean' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'featureValueType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'booleanValue' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetEventPreviewDataQuery__
 *
 * To run a query within a React component, call `useGetEventPreviewDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventPreviewDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventPreviewDataQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetEventPreviewDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventPreviewDataQuery, GetEventPreviewDataQueryVariables>) {
  return ApolloReactHooks.useQuery<GetEventPreviewDataQuery, GetEventPreviewDataQueryVariables>(GetEventPreviewDataDocument, baseOptions);
}
export function useGetEventPreviewDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventPreviewDataQuery, GetEventPreviewDataQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetEventPreviewDataQuery, GetEventPreviewDataQueryVariables>(GetEventPreviewDataDocument, baseOptions);
}
export type GetEventPreviewDataQueryHookResult = ReturnType<typeof useGetEventPreviewDataQuery>;
export type GetEventPreviewDataLazyQueryHookResult = ReturnType<typeof useGetEventPreviewDataLazyQuery>;
export type GetEventPreviewDataQueryResult = Apollo.QueryResult<GetEventPreviewDataQuery, GetEventPreviewDataQueryVariables>;
export const GetEventDelayShipSettingDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetEventDelayShipSetting' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getRegistryEventData' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hideDelayShipSetting' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetEventDelayShipSettingQuery__
 *
 * To run a query within a React component, call `useGetEventDelayShipSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventDelayShipSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventDelayShipSettingQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetEventDelayShipSettingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEventDelayShipSettingQuery, GetEventDelayShipSettingQueryVariables>) {
  return ApolloReactHooks.useQuery<GetEventDelayShipSettingQuery, GetEventDelayShipSettingQueryVariables>(GetEventDelayShipSettingDocument, baseOptions);
}
export function useGetEventDelayShipSettingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEventDelayShipSettingQuery, GetEventDelayShipSettingQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<GetEventDelayShipSettingQuery, GetEventDelayShipSettingQueryVariables>(GetEventDelayShipSettingDocument, baseOptions);
}
export type GetEventDelayShipSettingQueryHookResult = ReturnType<typeof useGetEventDelayShipSettingQuery>;
export type GetEventDelayShipSettingLazyQueryHookResult = ReturnType<typeof useGetEventDelayShipSettingLazyQuery>;
export type GetEventDelayShipSettingQueryResult = Apollo.QueryResult<GetEventDelayShipSettingQuery, GetEventDelayShipSettingQueryVariables>;
